<section class="landing-inversores__value-props landing-inversores__container">
  <div class="landing-inversores__value-props-intro">
    <p class="landing-inversores__eyebrow">Diferenciadores</p>
    <h2 class="landing-inversores__section-title">La diferencia de invertir con Inviertis</h2>
    <p class="landing-inversores__section-subtitle">
      Activos reales del producto que marcan la distancia frente a la competencia.
    </p>
  </div>

  <div class="landing-inversores__value-props-grid">
    <div class="landing-inversores__card landing-inversores__shadow-soft landing-inversores__value-card" *ngFor="let d of differentiators">
      <landing-inversores-icon [name]="d.icon" class="landing-inversores__value-card-icon"></landing-inversores-icon>
      <h3 class="landing-inversores__value-card-title">{{ d.title }}</h3>
      <p class="landing-inversores__value-card-desc">{{ d.desc }}</p>
    </div>
  </div>
</section>